<template>
	<tr v-bind:class="{ error }">
		<td>
			<el-input v-model="patient.name"
				v-bind:class="{ valid: validName, error: nameError }"
				v-bind:disabled="enrolling"
			 	type="text"
				ref="name"
				placeholder="Full Name"
				autocomplete="new-password"
				@blur="reverseName"
				@change="changed">
			</el-input>
			<label v-if="error">{{ nameError }}</label>
		</td>
		<td>
			<el-input v-model="patient.email"
				type="text"
				ref="email"
				v-bind:class="{ error: emailError }"
				v-bind:disabled="enrolling"
				placeholder="patient@example.com"
				autocomplete="new-password"
				@change="changed">
			</el-input>
			<label v-if="error">{{ emailError }}</label>
		</td>
		<td>
			<el-input v-model="patient.phone"
			 	type="text"
				ref="phone"
				v-bind:class="{ error: phoneError }"
				v-bind:disabled="enrolling"
				placeholder="(123) 456-7890"
				autocomplete="new-password"
				@change="changed">
			</el-input>
			<label v-if="error">{{ phoneError }}</label>
		</td>
		<td v-if="activeColumns.provider">
			<el-select v-model="patient.provider" 
				placeholder="Select Doctor Name"
				@change="changedFull">
				<el-option v-for="provider in getProviderList" 
					:key="provider.provider"
					:label="provider.name" 
					:value="provider.provider"></el-option>
			</el-select>
		</td>
		<td v-if="activeColumns.profile">
			<el-select v-model="profile" 
				placeholder="Select Profile"
				@change="changedFull">
				<el-option v-for="profile in getProfileList"
					:key="profile.id"
					:label="profile.title"
					:value="profile.id">
				</el-option>
			</el-select>
		</td>
		<td>
			<el-select v-model="schedule.event" 
				placeholder="Select Event"
				@change="changed"
				:disabled="profile === '' && activeColumns.profile">
				<el-option v-for="event in getEventList"
					:key="event.id"
					:label="event.name"
					:value="event.id">
				</el-option>
			</el-select>
		</td>
		<td>
			<el-date-picker v-model="schedule.time"
				type="date"
				placeholder="Select Date of Event"
				format="MMM d, yyyy"
				@change="changed"
				:disabled="profile === '' && activeColumns.profile"
				>
			</el-date-picker>
		</td>
		<td>
			<el-button v-if="!first" @click="remove" icon="el-icon-close" circle></el-button>
		</td>
	</tr>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
	name: 'add-patient-row',

	props: ['value', 'first', 'error', 'enrolling', 'active-columns', 'show-error'],

	data() {
		return {
			patient: this.value || {
				name: '',
				email: '',
				phone: '',
				provider: '',
				profile: ''
			},
			undo: false,
			schedule: {
				event: null,
				time: null
			},
			profile: ''
		}
	},

	mounted() {
		if (this.first) {
			if (this.error == null || this.nameError)
				this.$refs.name.focus()

			else if (this.emailError)
				this.$refs.email.focus()

			else if (this.phoneError)
				this.$refs.phone.focus()

			else
				this.$refs.name.focus()
		}
	},

	methods: {
		changed() {

			//Get values for name, email and phone for the patient
			const { name, email, phone } = this.patient
			// Set current values for provider and profile from patient
			let { provider } = this.patient
			let profile = this.profile !== "" ? [this.profile] : null
			// If provider columns doesn't exits, means only one provider 
			// So set provider at that provider
			if(!this.activeColumns.provider) {
				provider = this.getProviderList[0].provider
			}

			// If provider and profiles columns don't exist, means only one provider and one profile
			// Set the profile as that single profile
			if(!this.activeColumns.provider && !this.activeColumns.profile) {
				profile = [this.getProviderProfileList[0].id]
			}
			// If provider has a single profile but provider has been selected
			else if(!this.activeColumns.profile && this.patient.provider !== '') {
				profile = this.getProfileList.map(({ id }) => id)
			}
			let patientInfo = {
				name,
				email,
				phone
			}
			if((this.schedule.event !== null && this.schedule.event !== '')  && this.schedule.time !== null )
				patientInfo.schedule = [{
					event: this.schedule.event,
					time: this.schedule.time.setHours(12) + 123,
					provider: provider
				}]
			else if(provider && profile && !this.schedule.event && !this.schedule.time) {
				patientInfo.connect = [{
					profile: profile,
					provider: provider
				}]
			}

			// Updating patient via v-model event `input`
			this.$emit('input', patientInfo)
		},
		changedFull() {
			this.schedule.event = ''
			this.changed()
		},
		remove() {
			this.$emit('remove')
		},
		/**
		 * @func reverseName
		 * @desc Reverses the name from last, first to first, last
		 */
		reverseName() {
			var index = this.patient.name.indexOf(',')
			if (index > 0 && ! this.undo) {
				this.patient.name = this.patient.name.substring(index + 1).trim() + ' ' + this.patient.name.substring(0, index)
			}
		},
		validName() {
			if (this.patient.name.length > 0)
				return this.patient.name.indexOf(' ') > 0
			return null
		},
		/**
		 * Sorting functions for events
		 * @param {Object} eventA Event object for comparison
		 * @param {Object} eventB Event object for comparison
		 */
		sortEvent(eventA, eventB) {
			// Convert to lowercase of comparison
			const nameA = eventA.name ? eventA.name.toLowerCase() : '',
				nameB = eventB.name ? eventB.name.toLowerCase() : ''
			return nameB > nameA ? -1 : 0
		}
	},

	computed: {
		...mapGetters('provider', [
			'getProviderList',
			'getProviderProfileList',
			'getAllProviderProfileList',

		]),
		...mapState('content', {
			eventObj: state => state.data.event
		}),
		nameError() {
			if (this.error) {
				if (this.error.code == 'InvalidName')
					return 'Please enter a first and last name'
				if (this.error.code == 'MissingEmailPhone')
					return 'A valid email or phone number is required'
			}
			return null
		},
		hasEmail() {
			return this.patient.email.trim().length > 0
		},
		emailError() {
			if (this.error) {
				if (this.error.code === 'UserExists')
					return 'Email already in use'
				else if(this.error.code === 'InvalidEmail')
					return 'This is an Invalid Email'
			}
			return null
		},
		hasPhone() {
			return this.patient.phone.trim().length > 0
		},
		phoneError() {
			if (this.error) {
				if (this.error.code === 'PhoneInUse')
					return 'Phone already in use'
				if (this.error.code === 'InvalidPhone')
					return 'Invalid phone number'
			}
			return null
		},
		getProfileList() {
			try {
				let profileList = this.getAllProviderProfileList
				if(this.patient.provider !== "")
					profileList = profileList.filter((profile) => profile.providerId === this.patient.provider)
				profileList = profileList.reduce((profileAcc,profile) => {
						const { id, title, event, providerId } = profile
						return {
							...profileAcc, 
							[id]: { 
								id,
								title,
								event,
								providerId
							}
						}
					}, {})
				return Object.values(profileList)
			} catch (error) {
				console.error(error)
				return []
			}
			
		},
		getEventList() {
			if(this.eventObj) {
				if(this.profile !== '') {
					const profile = this.getProfileList.find((profile) => profile.id === this.profile)
					
					if(profile)
						return profile.event.map((eventId) => this.eventObj[eventId]).filter((event) => event).sort(this.sortEvent)
				}

				else if(!this.activeColumns.profile && !this.activeColumns.provider) {
					return this.getProviderProfileList[0].event.map((eventId) => this.eventObj[eventId]).filter((event) => event).sort(this.sortEvent)
				}
				else if(!this.activeColumns.profile && this.patient.provider !== '') {
					const profile = this.getProfileList.find((profile) => profile.providerId = this.patient.provider)
					
					if(profile)
						return profile.event.map((eventId) => this.eventObj[eventId]).filter((event) => event).sort(this.sortEvent)
				}
					
			}
			return []
		},

	}
}
</script>

<style lang="scss" scoped>
@import "style.scss";
</style>

<style scoped>
td >>> .el-date-editor.el-input {
	width: auto;
}

td >>> .el-input__inner::placeholder {
  font-size: 14px;
}
</style>